globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactsImportFile = (function(superClass) {

  utils.extend(ContactsImportFile, superClass);

  function ContactsImportFile() {
    return ContactsImportFile.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactsImportFile.prototype, {
    init: function() {
      var modal = this;

      var $modal = $('.modal');
      var $importBtn = $modal.find('.crm-import-contacts-btn');
      var $fileInput = $modal.find('.crm-import-contacts-excel-file-input');
      var $formContainer = $modal.find('.crm-import-contacts-data-form-container');
      var $submitBtn = $formContainer.find('.modal-submit-btn');
      var $optInCheckbox = $formContainer.find('input[name="emailing_opt_in_declared_by_user"]');


      $importBtn.on('click', function(e) {
        e.preventDefault();
        $fileInput.trigger('click');
      });

      appCustomerSpace.LimitlessPlugins.Selects.Single.init(modal.$html);
      exportExcelActionCable(modal.$html);

      $fileInput.on('change', function() {
        var $input     = $(this);

        if($input.val() != undefined) {
          $importBtn.hide();
          $input.show();
          if ($optInCheckbox.is(':checked')) {
            $submitBtn.removeAttr('disabled');
          } else {
            $submitBtn.attr('disabled', true);
          }
        }
      });

      $optInCheckbox.on('change', function() {
        var $input = $(this);

        if($input.is(':checked') && $fileInput.val() != undefined && $fileInput.val().length > 0) {
          $submitBtn.removeAttr('disabled');
        } else {
          $submitBtn.attr('disabled', true);
        }
      });

      $modal.on('click', '.modal-submit-btn', function(e) {
        e.preventDefault();
        appCustomerSpace.Loader().start({ $container: modal.$html.find('.modal-content') });
        var $body = $('body');
        var $html = $body.find('.crm-import-contact-xlsx');
        var $btn = $(e.target);
        var form = $btn.closest('form')
        var url = form.attr('action');

        $.ajax({
          type: "POST",
          url: url,
          data: new FormData(form[0]),
          processData: false,
          contentType: false,
          success: function(data) {
            if(data.response && data.html) {
              appCustomerSpace.Loader().stop();
              modal.close(function(){
                appCustomerSpace.Modal.mountCurrentModal($(data.html)).open({});
              });
            } else {
              alert("Aucun fichier importé");
            }
          }
        });
      })

      return ContactsImportFile.__super__.init.apply(this, arguments);
    },
  });

  return ContactsImportFile;

})(appCustomerSpace.Modal);
